import { Alert, Typography } from '@mui/material';
import React from 'react';

import { ContactFlowNodeProps } from '..';
import BaseNode from '../BaseNode';

export default function DefaultNode(props: ContactFlowNodeProps) {
  return (
    <BaseNode
      {...props}
      title={`Unknown <${props.data.type}>`}
      renderParameter={(parameter) => (
        <>
          <Typography>No config for this action type.</Typography>
          <Alert
            variant='outlined'
            severity='warning'
            sx={{
              whiteSpace: 'pre-wrap',
            }}>
            {JSON.stringify(parameter, undefined, 2)}
          </Alert>
        </>
      )}
    />
  );
}
